import { DynamicStandaloneIcon, DynamicStandaloneIconProps } from '@/components/Icon';
import { componentTheme } from '@/styles/BreakingNews';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type BreakingNewsItemIconProps = DynamicStandaloneIconProps;

export const BreakingNewsItemIconComponent: StandaloneComponent<BreakingNewsItemIconProps> = (props) => {
  return (
    <DynamicStandaloneIcon
      {...mergeProps(
        {
          options: {
            theme: componentTheme('icon'),
          },
          name: 'sliderArrow',
        },
        props
      )}
    />
  );
};
